import { useState } from "react";
import { Field, useAction } from "../../components/ui.tsx";
import { post } from "../../lib/api.ts";

export function AccountSettings({ onLogout }: { onLogout: () => void }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [again, setAgain] = useState("");
  const [change, changing] = useAction(async () => {
    await post("/api/auth/password", { current, next });
    setCurrent("");
    setNext("");
    setAgain("");
  }, "Password changed. Other browsers are signed out.");
  const [logout] = useAction(async () => {
    await post("/api/auth/logout");
    onLogout();
  });
  const mismatch = again.length > 0 && again !== next;

  return (
    <>
      <div className="pagehead">
        <div>
          <h1>Account</h1>
          <div className="sub">Single-user dashboard login.</div>
        </div>
        <button className="btn" onClick={() => logout()}>
          Sign out
        </button>
      </div>
      <form
        className="card"
        style={{ maxWidth: 520 }}
        onSubmit={(e) => {
          e.preventDefault();
          void change();
        }}
      >
        <h2>Change password</h2>
        <Field label="Current password">
          <input type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} />
        </Field>
        <Field label="New password" hint="At least 8 characters.">
          <input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} />
        </Field>
        <Field label="New password again" error={mismatch ? "Does not match" : undefined}>
          <input type="password" autoComplete="new-password" value={again} onChange={(e) => setAgain(e.target.value)} />
        </Field>
        <div>
          <button className="btn primary" type="submit" disabled={changing || !current || next.length < 8 || next !== again}>
            Change password
          </button>
        </div>
      </form>
    </>
  );
}
